var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart-simple-solid",
    d: "M8.571,34.571A2.572,2.572,0,0,1,11.143,32h1.714a2.572,2.572,0,0,1,2.571,2.571V53.429A2.572,2.572,0,0,1,12.857,56H11.143a2.572,2.572,0,0,1-2.571-2.571ZM0,44.857a2.572,2.572,0,0,1,2.571-2.571H4.286a2.572,2.572,0,0,1,2.571,2.571v8.571A2.572,2.572,0,0,1,4.286,56H2.571A2.572,2.572,0,0,1,0,53.429Zm19.714-9.429h1.714A2.572,2.572,0,0,1,24,38V53.429A2.572,2.572,0,0,1,21.429,56H19.714a2.572,2.572,0,0,1-2.571-2.571V38A2.572,2.572,0,0,1,19.714,35.429Z",
    transform: "translate(0 -32)",
    fill: "inharit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.bb38e06ccfbde99b03a3e5f9d16c0e6d.svg";
export { ForwardRef as ReactComponent };